import { ListPageComponent } from "@framework/components/mf-list-page/mf-list-page.component";
import { UserList } from "@common/application/entities/User";
import * as Organisation from "@common/application/entities/Organisation";
import * as WorkOrder from "@common/application/entities/WorkOrder";
import * as JobCard from "@common/application/entities/JobCard";
import * as Invoice from "@common/application/entities/Invoice";
import * as PartyContact from "@common/application/entities/PartyContact";
import * as PartyAddress from "@common/application/entities/PartyAddress";
import * as Requisition from "@common/application/entities/Requisition";
import * as RequisitionItem from "@common/application/entities/RequisitionItem";
import * as DetailedWipReport from "@common/application/entities/DetailedWipReport";
import * as RequisitionItemWorkflow from "@common/application/entities/RequisitionItemWorkflow";
import * as RequisitionPartial from "@common/application/entities/RequisitionPartial";
import * as RequisitionPartialWorkflow from "@common/application/entities/RequisitionPartialWorkflow";
import * as RequisitionWorkflow from "@common/application/entities/RequisitionWorkflow";
import * as RequisitionFileCabinet from "@common/application/entities/RequisitionFileCabinet";
import * as RequisitionItemFileCabinet from "@common/application/entities/RequisitionItemFileCabinet";
import * as AuditTrail from "@common/application/entities/AuditTrail";
import * as Supplier from "@common/application/entities/Supplier";
import * as Permission from "@common/application/entities/Permission";
import * as Role from "@common/application/entities/Role";
import * as RoleJob from "@common/application/entities/RoleJob";
import * as User from "@common/application/entities/User";
import * as Site from "@common/application/entities/Site";
import * as ProjectJobNumber from "@common/application/entities/ProjectJobNumber";
import * as RoleProjectJobNumber from "@common/application/entities/RoleProjectJobNumber"
import * as RoleWarehouse from "@common/application/entities/RoleWarehouse";;
import * as RoleSite from "@common/application/entities/RoleSite";
import * as StockItem from "@common/application/entities/StockItem";
import * as StockItemSupplier from "@common/application/entities/StockItemSupplier";
import * as StockItemFileCabinet from "@common/application/entities/StockItemFileCabinet";
import * as SupplierFileCabinet from "@common/application/entities/SupplierFileCabinet";
import { IDetailComponent } from "../mf-blade/mf-blade.component";
import { IDataEndPoint } from "../../interfaces/IEntity";
import { IApiServiceCommand } from "../../../services/api/api.service";
import * as app from '@framework/app';
import { appSettings } from '../../../modules/shared/components/appSettings';


export class RoleOrganisationList extends ListPageComponent {
  protected listPageComponentList: Organisation.RoleOrganisationList = new Organisation.RoleOrganisationList();
}

export class RolePermissionList extends ListPageComponent {
  protected listPageComponentList: Permission.RolePermissionList = new Permission.RolePermissionList();
}

export class OrganisationRoleList extends ListPageComponent {
  protected listPageComponentList: Role.OrganisationRoleList = new Role.OrganisationRoleList();
}

export class OrganisationUserList extends ListPageComponent {
  protected listPageComponentList: User.OrganisationUserList = new User.OrganisationUserList();
}

export class UserOrganisationList extends ListPageComponent {
  protected listPageComponentList: Organisation.UserOrganisationList = new Organisation.UserOrganisationList();
}

export class UserRoleList extends ListPageComponent {
  protected listPageComponentList: Role.UserRoleList = new Role.UserRoleList();
}

export class UserPermissionList extends ListPageComponent {
  protected listPageComponentList: Permission.UserPermissionList = new Permission.UserPermissionList();
}

export class RoleJobList extends ListPageComponent {
  protected listPageComponentList: RoleJob.RoleJobList = new RoleJob.RoleJobList();
}
export class StockItemListPageComponent extends ListPageComponent {
  protected listPageComponentList: RoleJob.RoleJobList = new RoleJob.RoleJobList();
}


export class UserRoleJobList extends ListPageComponent {
  protected listPageComponentList: User.UserRoleJobList = new User.UserRoleJobList();
}

export class UserListPageComponent extends ListPageComponent {
  protected listPageComponentList: UserList = new UserList();
  protected showFilterColOnTable: boolean = true;
  protected loadOnlyOnEntityId: boolean = false;
};

export class SiteListPageComponent extends ListPageComponent {
  protected listPageComponentList: Site.SiteList = new Site.SiteList();
  protected loadOnlyOnEntityId: boolean = false;
};


export class SiteProjectJobNumbersListPageComponent extends ListPageComponent {
  protected listPageComponentList: ProjectJobNumber.SiteProjectJobNumberList = new ProjectJobNumber.SiteProjectJobNumberList();
};


export class OrgListPageComponent extends ListPageComponent {
  protected listPageComponentList: Organisation.UserOrganisationList = new Organisation.UserOrganisationList();
  protected showFilterColOnTable: boolean = true;
  protected loadOnlyOnEntityId: boolean = false;
};
export class PartyContactSpecificPartyListPageComponent extends ListPageComponent {
  protected listPageComponentList: PartyContact.PartyContactSpecificPartyList = new PartyContact.PartyContactSpecificPartyList();
  protected showFilterColOnTable: boolean = true;
};
export class PartyAddressSpecificPartyListPageComponent extends ListPageComponent {
  protected listPageComponentList: PartyAddress.PartyAddressSpecificPartyList = new PartyAddress.PartyAddressSpecificPartyList();
  protected showFilterColOnTable: boolean = true;
};

export class PartyContactListPageComponent extends ListPageComponent {
  protected listPageComponentList: PartyContact.PartyContactList = new PartyContact.PartyContactList();
  protected showFilterColOnTable: boolean = true;
};
export class PartyAddressListPageComponent extends ListPageComponent {
  protected listPageComponentList: PartyAddress.PartyAddressList = new PartyAddress.PartyAddressList();
  protected showFilterColOnTable: boolean = true;
};


export class GlobalRoleListPageComponent extends ListPageComponent {
  protected listPageComponentList: Role.OrganisationRoleList = new Role.OrganisationRoleList();
  protected showFilterColOnTable: boolean = true;
  protected loadOnlyOnEntityId: boolean = false;
};

export class WorkOrderListComponent extends ListPageComponent {
  protected listPageComponentList: WorkOrder.WorkOrderList = new WorkOrder.WorkOrderList();
  protected loadOnlyOnEntityId: boolean = false;
};
export class JobCardListEstimateComponent extends ListPageComponent {
  protected listPageComponentList: JobCard.JobCardListEstimate = new JobCard.JobCardListEstimate();
};
export class JobCardListActualComponent extends ListPageComponent {
  protected listPageComponentList: JobCard.JobCardListActual = new JobCard.JobCardListActual();
};
export class JobCardListJobcardsComponent extends ListPageComponent {
  protected listPageComponentList: JobCard.JobCardListJobCards = new JobCard.JobCardListJobCards();
};
export class JobCardListInvoiceComponent extends ListPageComponent {
  protected listPageComponentList: JobCard.JobCardListInvoice = new JobCard.JobCardListInvoice();
};
export class InvoiceListPageComponent extends ListPageComponent {
  protected listPageComponentList: Invoice.InvoiceList = new Invoice.InvoiceList();
};


export class InvoiceCustomListPageComponent extends ListPageComponent {
  protected listPageComponentList: Invoice.InvoiceList = new Invoice.InvoiceList();
  protected loadOnlyOnEntityId: boolean = false;
  protected showFilterColOnTable: boolean = true;
  protected _canAdd: boolean = false;
  reloadTableOnNotificationReceived = true;
};


export class InvoiceFullListPageComponent extends ListPageComponent {
  protected listPageComponentList: Invoice.InvoiceFullList = new Invoice.InvoiceFullList();
  protected loadOnlyOnEntityId: boolean = false;
};

export class RequisitionListPageComponent extends ListPageComponent {
  protected listPageComponentList: Requisition.RequisitionList = new Requisition.RequisitionList();
  protected showFilterColOnTable: boolean = true;
  protected loadOnlyOnEntityId: boolean = false;
 
};
export class DetailedWIPReportListPageComponent extends ListPageComponent {
	protected listPageComponentList: DetailedWipReport.DetailedWipReportList = new DetailedWipReport.DetailedWipReportList();

	protected _canAdd: boolean = false;
	protected showFilterColOnTable: boolean = false;
	protected loadOnlyOnEntityId: boolean = false;
	protected usev1: boolean = true;
};
export class RequisitionItemListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItem.RequisitionItemList = new RequisitionItem.RequisitionItemList();

  protected usev1: boolean = true;
};
export class RequisitionItemDetailReportListPageComponent extends ListPageComponent {
	protected listPageComponentList: RequisitionItem.RequisitionItemDetailReportList = new RequisitionItem.RequisitionItemDetailReportList();

  protected usev1: boolean = true;
};
export class RequisitionItemReportListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItem.RequisitionItemReportList = new RequisitionItem.RequisitionItemReportList();

  protected showFilterColOnTable: boolean = true;
  protected loadOnlyOnEntityId: boolean = true;
};

export class RequisitionReportActionsRequiredListPageComponent extends ListPageComponent {
  protected listPageComponentList: Requisition.RequisitionReportActionRequiredList = new Requisition.RequisitionReportActionRequiredList();

  protected showFilterColOnTable: boolean = true;
  protected loadOnlyOnEntityId: boolean = true;
};
export class RequisitionItemReportOutstandingItemsListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItem.RequisitionItemReportOutstandingItemsList = new RequisitionItem.RequisitionItemReportOutstandingItemsList();

  protected showFilterColOnTable: boolean = true;
  protected loadOnlyOnEntityId: boolean = true;
};

export class RequisitionPartialRequisitionItemListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItem.PartialRequisitionItemList = new RequisitionItem.PartialRequisitionItemList();
  protected _canAdd: boolean = false;
};
export class RequisitionItemMyItemsListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItem.RequisitionItemMyItemsList = new RequisitionItem.RequisitionItemMyItemsList();
};
export class RequisitionItemWorkflowListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItemWorkflow.RequisitionItemWorkflowList = new RequisitionItemWorkflow.RequisitionItemWorkflowList();
  protected _canAdd: boolean = false;
};
export class RequisitionPartialListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionPartial.RequisitionPartialList = new RequisitionPartial.RequisitionPartialList();
  protected _canAdd: boolean = false;
};
export class RequisitionPartialWorkflowListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionPartialWorkflow.RequisitionPartialWorkflowList = new RequisitionPartialWorkflow.RequisitionPartialWorkflowList();
  protected _canAdd: boolean = false;
};
export class RequisitionWorkflowListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionWorkflow.RequisitionWorkflowList = new RequisitionWorkflow.RequisitionWorkflowList();
  protected _canAdd: boolean = false;
};
export class RequisitionFileCabinetListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionFileCabinet.RequisitionFileCabinetList = new RequisitionFileCabinet.RequisitionFileCabinetList();
};
export class RequisitionItemFileCabinetListPageComponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItemFileCabinet.RequisitionItemFileCabinetList = new RequisitionItemFileCabinet.RequisitionItemFileCabinetList();
};
export class AuditTrailReqListPageComponent extends ListPageComponent {
  protected listPageComponentList: AuditTrail.AuditTrailReqList = new AuditTrail.AuditTrailReqList();
  protected _canAdd: boolean = false;
};
export class AuditTrailReqItemListPageComponent extends ListPageComponent {
  protected listPageComponentList: AuditTrail.AuditTrailReqItemList = new AuditTrail.AuditTrailReqItemList();
  protected _canAdd: boolean = false;
};

export class SupplierListPageComponent extends ListPageComponent {
  protected listPageComponentList: Supplier.SupplierList = new Supplier.SupplierList();
  protected loadOnlyOnEntityId: boolean = false;  
};
export class RoleSiteListPageComponent extends ListPageComponent {
  protected listPageComponentList: RoleSite.RoleSiteList = new RoleSite.RoleSiteList();
  protected _canAdd: boolean = false;
};
export class RoleWarehouseListPageComponent extends ListPageComponent {
  protected listPageComponentList: RoleWarehouse.RoleWarehouseList = new RoleWarehouse.RoleWarehouseList();
  protected _canAdd: boolean = false;
};
export class RoleProjectJobNumberListPageComponent extends ListPageComponent {
  protected listPageComponentList: RoleProjectJobNumber.RoleProjectJobNumberList = new RoleProjectJobNumber.RoleProjectJobNumberList();
  protected _canAdd: boolean = false;
};
export class RoleSitePerUserListPageComponent extends ListPageComponent {
  protected listPageComponentList: RoleSite.RoleSiteListPerUser = new RoleSite.RoleSiteListPerUser();
  protected _canAdd: boolean = false;
};
export class RoleProjectPerUserJobNumberListPageComponent extends ListPageComponent {
  protected listPageComponentList: RoleProjectJobNumber.RoleProjectJobNumberPerUserList = new RoleProjectJobNumber.RoleProjectJobNumberPerUserList();
  protected _canAdd: boolean = false;
};

export class StockItemSupplierListPageCompoment extends ListPageComponent {
  protected listPageComponentList: StockItemSupplier.StockItemSupplierList = new StockItemSupplier.StockItemSupplierList();
};

export class AuditTrailStockItemListPageComponent extends ListPageComponent {
  protected listPageComponentList: AuditTrail.StockItemList = new AuditTrail.StockItemList();
  protected _canAdd: boolean = false;
};
export class AuditTrailStockItemSupplierListPageComponent extends ListPageComponent {
  protected listPageComponentList: AuditTrail.StockItemSupplierList = new AuditTrail.StockItemSupplierList();
  protected _canAdd: boolean = false;
};
export class StockItemFileCabinetPicturesListPageComponent extends ListPageComponent {
  protected listPageComponentList: StockItemFileCabinet.StockItemFileCabinetPictureList = new StockItemFileCabinet.StockItemFileCabinetPictureList();
  protected _tableReadonly: boolean = true;
};

export class StockItemFileCabinetDocumentsListPageComponent extends ListPageComponent {
  protected listPageComponentList: StockItemFileCabinet.StockItemFileCabinetDocList = new StockItemFileCabinet.StockItemFileCabinetDocList();
  protected _tableReadonly: boolean = true;
};

export class SupplierFileCabinetDocumentsListPageComponent extends ListPageComponent {
  protected listPageComponentList: SupplierFileCabinet.SupplierFileCabinetList = new SupplierFileCabinet.SupplierFileCabinetList();
  protected _tableReadonly: boolean = true;
};

export class SupplierPartyContactListPageComponent extends ListPageComponent {
  protected listPageComponentList: PartyContact.SupplierPartyContactList = new PartyContact.SupplierPartyContactList();
};

export class SupplierPartyAddressListPageComponent extends ListPageComponent {
  protected listPageComponentList: PartyAddress.SupplierPartyAddressList = new PartyAddress.SupplierPartyAddressList();
};

export class RequisitionItemExpendListPageCommponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItem.RequisitionItemGraphExpendListColumns = new RequisitionItem.RequisitionItemGraphExpendListColumns();
  protected loadOnlyOnEntityId: boolean = false;
  protected _canAdd: boolean = false;
};
export class RequisitionItemExpendPerBuyerListPageCommponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItem.RequisitionItemGraphExpendPerBuyerListColumns = new RequisitionItem.RequisitionItemGraphExpendPerBuyerListColumns();
  protected loadOnlyOnEntityId: boolean = false;
  protected _canAdd: boolean = false;
};
export class RequisitionItemExpendPerJobListPageCommponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItem.RequisitionItemGraphExpendPerJobListColumns = new RequisitionItem.RequisitionItemGraphExpendPerJobListColumns();
  protected loadOnlyOnEntityId: boolean = false;
  protected _canAdd: boolean = false;
};

export class RequisitionItemExpendTimeListPageCommponent extends ListPageComponent {
  protected listPageComponentList: RequisitionItem.RequisitionItemGraphExpendPerTimeListColumns = new RequisitionItem.RequisitionItemGraphExpendPerTimeListColumns();
  protected loadOnlyOnEntityId: boolean = false;
  protected _canAdd: boolean = false;
};


